@if (isOpen()) {
  <div
    #modalBackdrop
    class="modal__backdrop"
    (click)="onBackdropClick($event)"
    (keydown)="onKeyDown($event)"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="modalConfig().title ? 'modal-title' : null"
  >
    <div
      class="modal__container"
      [ngStyle]="modalStyles()"
      (click)="$event.stopPropagation()"
    >
      <app-modal-header
        [title]="modalConfig().title"
        [showCloseButton]="modalConfig().showCloseButton ?? true"
        (closeClicked)="close()"
      ></app-modal-header>
      <div class="modal__content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
}

